import { render, staticRenderFns } from "./WidgetGridFormDialog.vue?vue&type=template&id=96d0e816&"
import script from "./WidgetGridFormDialog.vue?vue&type=script&lang=ts&"
export * from "./WidgetGridFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports